import { Component, inject } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

// Components
import { LoadingButtonComponent } from "../../../shared/components/loading-button/loading-button.component";
import { OtpComponent } from "../otp/otp.component";
import { ChangePasswordComponent } from "../change-password/change-password.component";

// FontAwesome
import { faAt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// Services 
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../../shared/services/toast.service';

// RxJS
import { finalize } from 'rxjs';


@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    RouterModule,
    LoadingButtonComponent,
    FontAwesomeModule,
    OtpComponent,
    ChangePasswordComponent
],
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly authSrv = inject(AuthService);
  private readonly toastSrv = inject(ToastService);
  
  faAt = faAt;

  loading = false;
  nextStep!: string | null;

  emailForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  sendForgotPasswordEmail() {
    if (this.emailForm.valid) {
      this.loading = true;
      this.authSrv.sendForgotPasswordEmail(this.emailForm.get('email')?.value)
        .pipe(finalize(() => this.loading = false))
        .subscribe(
          {
            next: (res) => {
              console.debug('OTP Next Step: ', res.nextStep);
              this.nextStep = res.nextStep;
              this.toastSrv.show({ type: 'success', message: res.message });
            }
          });
    }
  }
}
